import Model from '~/models/base/Model';

/**
 * class representing user's role
 * @extends Model
 * @author rn
 */
export default class Role extends Model {
    static _url = `${Model._url}/roles`;

    constructor(id = null, options) {
        super(id, options);
    }

    static all(include_deleted) {
        const requestUrl = '/roles/';
        const requestPayload = {
            params: {
                include_deleted: include_deleted ?? false
            }
        };
        return this.api.get(requestUrl, requestPayload);
    }

    //rn: new profiles/roles api
    static getProfiles(includeDeleted) {
        const requestUrl = `${this._url}/roles/`;
        const requestPayload = {
            params: {
                include_deleted: includeDeleted ?? false
            }
        };
        return this.api.get(requestUrl, requestPayload);
    }

    static getProfileDetails(profileId) {
        const requestUrl = `${this._url}/roles/${profileId}/`;
        return this.api.get(requestUrl);
    }

    static getSuperuserDetails() {
        const requestUrl = `${this._url}/roles/superuser/`;
        return this.api.get(requestUrl);
    }

    static newProfile(params) {
        const requestUrl = `${this._url}/roles/`;
        const requestPayload = params ?? {};
        return this.api.post(requestUrl, requestPayload);
    }

    static editProfile(profileId, params) {
        const requestUrl = `${this._url}/roles/${profileId}/`;
        const requestPayload = params ?? {};
        return this.api.patch(requestUrl, requestPayload);
    }

    static deleteProfile(profileId) {
        const requestUrl = `${this._url}/roles/${profileId}/delete/`;
        return this.api.put(requestUrl);
    }

    static restoreProfile(profileId) {
        const requestUrl = `${this._url}/roles/${profileId}/restore/`;
        return this.api.put(requestUrl);
    }

    static cipPermissions() {
        const requestUrl = `${this._url}/roles/cip-conversion-table/`;
        return this.api.get(requestUrl);
    }
}
